import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { LeaveService } from 'src/app/shared/services/leaveservices/leave.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import Swal from 'sweetalert2';
// import { ActivatedRoute } from '@angular/router';



@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule],
})
export class MainComponentLeave implements OnInit {
  deleteValueModal: any;
  typeArr: any = [];
  public user: any = [];
  public absent: any = '';
  public showSpinner = true;
  public checkData = false;
  public stats: any = [];
  public backgroundColor: any;
  public titleColor: any;
  public bdrColor: any;
  public statusColor: any;
  public checkEndDate = false;
  public paidLeaves = 0;
  public rejectedLeaves = 0;
  public renewalYear = new Date().getFullYear();
  selectedMode: any;
  datamode: any;
  userInfo: any;
  colormode: any;
  refresh: any;
  total_leaves: any;
  current_user: any;
  current_userrole: any;
  currentUser_dep: any;
  current_userid: any;
  admindetail: any;
  adminstatus: any;
  dep: any;
  userRole: any;
  currentLeaveDetail: any;
  remainleaves: any;
  // private route: ActivatedRoute,
  constructor(private leaveService: LeaveService, public router: Router,
    private sharedmode: SharedModeService,
    public dashboardService: DashboardService,

  ) {
    this.showSpinner = true;
    this.user_refresh();

    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();

  }

  ngOnInit(): void {
    this.getAllLeaveData();
    this.getLeaveStats();
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }

  user_refresh() {
    this.dashboardService.getuserrefresh().then((value) => {
      this.refresh = value.data.user
      this.user = this.refresh;

    })

  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  getAllLeaveData() {
    this.leaveService.getAllLeave().then((value) => {
      value.data.forEach((x: any) => {
        const obj = x;
        if (x.status == "approved") {
          obj.bdrColor = "#71D97B";
          obj.statusColor = "#03670D";
          if (x.leave_payment_status == "paid") {
            obj.backgroundColor = "#EDFFED";
            obj.titleColor = "#03670D";
            if (x.leave_type_id == 3) {
              this.paidLeaves = this.paidLeaves + 0.5;
            }
            else {
              const leaveDays = this.calculateDiff(x.start_date, x.end_date,)
              this.paidLeaves = this.paidLeaves + leaveDays;
            }
          } else {
            obj.backgroundColor = "#FFF6E0";
            obj.titleColor = "#FFB700";
          }
        } else if (x.status == "rejected") {
          obj.bdrColor = "red";
          obj.statusColor = "#FFFFF";
          obj.titleColor = "#212529";
          obj.backgroundColor = "#FFE3EC";
          const leaveDays = this.calculateDiff(x.start_date, x.end_date)
          this.rejectedLeaves = this.rejectedLeaves + leaveDays;
        } else {
          obj.bdrColor = "#175F87";
          obj.statusColor = "#175F87";
          if (x.leave_payment_status == "paid") {
            obj.backgroundColor = "#ffffff";
            obj.titleColor = "#03670D";
          } else {
            obj.backgroundColor = "#FFF6E0";
            obj.titleColor = "#FFB700";
          }
        }
        this.typeArr.push(obj)

      });

      this.showSpinner = false;
    });
  }

  onSubmit(f: NgForm) {
    this.showSpinner = true;
    // alert("submitted");
    this.typeArr = [];
    this.leaveService
      .getLeaveFilter(
        f.value.startdate,
        f.value.enddate,
        f.value.month,
        f.value.leave_type_id
      )
      .then((value) => {
        // alert('after filter');
        this.showSpinner = false;
        this.typeArr = value.data;
      });
  }

  onReset() {
    this.showSpinner = true;
    this.getAllLeaveData();
  }



  getLeaveStats() {
    this.leaveService.getStatsFilter().then((value) => {
      this.absent = value.data.absents;

      this.stats = value.data.leaves;
      if (this.stats) {
        this.checkData = true;
      }
    });
  }

  showDetails(data: any) {
    // this.paySlip.getData(data);
    this.router.navigate(['/leaves-status'], {
      queryParams: { data: JSON.stringify(data) },
      skipLocationChange: true,
    });
  }
  deleteDetail(dataDelete: any) {
    this.deleteValueModal = dataDelete;
  }

  deleteLeave(data: any) {
    this.showSpinner = true;
    // delete module
    this.leaveService
      .deleteLeave(
        data.id
      )
      .then((value) => {
        this.showSpinner = false;
        if (value.success == true) {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
            title: 'Delete data Successfully',
            showConfirmButton: false,
            timer: 1500,
          });
          // this.router.navigate(['leaves']);

          window.location.reload();
          this.showSpinner = false;
        } else {
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
            title: value.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
    //
  }

  editLeave(data: any) {

    if (this.userInfo.theme_id == 1) {
      this.router.navigate(['/user-leaves/' + this.paidLeaves + '/' + this.rejectedLeaves], {
        queryParams: { data: JSON.stringify(data), isEdit: true },
        skipLocationChange: true,
      });
    } else if (this.userInfo.theme_id == 2) {
      this.router.navigate(['/user-leaves/' + this.paidLeaves + '/' + this.rejectedLeaves], {
        queryParams: { data: JSON.stringify(data), isEdit: true },
        skipLocationChange: true,
      });
    } else {
      this.router.navigate(['/apply-leaves/' + this.paidLeaves + '/' + this.rejectedLeaves], {
        queryParams: { data: JSON.stringify(data), isEdit: true },
        skipLocationChange: true,
      });
    }

  }

  getLeaveColor(data: any) {
    if (data == 'pending') {
      return '#BAE6FF';
    }
    if (data == 'rejected') {
      return 'rgb(251 207 209)';
    }
    if (data == 'approved') {

      return '#BCFFC3';
    }
    return '';
  }

  calculateDiff(data_1: any, data_2: any) {
    const date1 = new Date(data_1);
    const date2 = new Date(data_2);

    const days = Math.floor(
      (date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24
    );
    return days + 1;
  }

  checkShort(end_date: any) {
    if (end_date) {

    } else {
      return true;
    }
    return false;
  }

  checkFull(end_date: any) {
    if (end_date) {
      return true;
    }
    return false;
  }

  isPaid(LeaveStatus: any) {
    if (LeaveStatus == "paid") {
      return true;
    }
    return false;
  }

  isUnPaid(LeaveStatus: any) {
    if (LeaveStatus == "unpaid") {
      return true;
    }
    return false;
  }

  getShift(shift: any) {
    if (shift == "first") {
      return "Morining";
    } else {
      return "Evening";
    }
  }

  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.total_leaves = this.userInfo?.total_leaves
      this.showSpinner = false;
    })

  }


  isAdmindata(leave: any): boolean {
    let isAdminData = false
    if (leave.leave_details.length > 0) {
      return isAdminData = true
    } else {
      return isAdminData = false
    }
  }

  // Call this method in your component where needed
  isShowApprovalButtons(leave: any): boolean {
    if (leave.leave_details.length > 0) {
      // user who sign up role
      let isButtonVissible = true;
      this.current_user = JSON.parse(this.user.user_role.user_roles)
      this.current_userrole = this.current_user?.role_type
      this.currentUser_dep = this.user?.department
      this.current_userid = this.user?.id
      leave.leave_details.forEach((detail: any) => {
        this.admindetail = detail?.admin
        this.adminstatus = detail?.status
        this.dep = detail?.user_dep
        this.userRole = detail?.user_role
        if (detail.admin_id == this.current_userid || (this.userRole == this.current_userrole && this.currentUser_dep == this.dep)) {
          isButtonVissible = false; // Hide button
        }

      });
      return isButtonVissible

    } else {
      return true
    }

  }
  isShowrejectstatus(leave: any): boolean {
    if (leave.leave_details.length > 0) {
      let isLeaveStatus = true;
      this.current_user = JSON.parse(this.user.user_role.user_roles)
      this.current_userrole = this.current_user?.role_type
      this.currentUser_dep = this.user?.department
      this.current_userid = this.user?.id
      leave.leave_details.forEach((detail: any) => {
        this.admindetail = detail?.admin
        this.adminstatus = detail?.status
        this.dep = detail?.user_dep
        this.userRole = detail?.user_role
        if (this.adminstatus == 'rejected') {
          isLeaveStatus = false; // Hide button
        }
      });
      return isLeaveStatus

    } else {
      return true
    }

  }

  isPendingstatus(leave: any): boolean {
    let ispendiingStatus = true
    if (leave.leave_details.length = 0) {
      ispendiingStatus = false
      return ispendiingStatus
    } else {
      return true
    }

  }

  showLeaveDetail(detail: any) {
    this.currentLeaveDetail = detail;
  }


  remainingLeaves() {
    this.showSpinner = true;
    this.dashboardService.getRemainingLeaves().then((value) => {
      this.remainleaves = value.data.data
    })
    this.showSpinner = false;
  }


}
